import { render, staticRenderFns } from "./QualificationPresetMobileCard.vue?vue&type=template&id=ddc8a10a&scoped=true"
import script from "./QualificationPresetMobileCard.vue?vue&type=script&lang=js"
export * from "./QualificationPresetMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc8a10a",
  null
  
)

export default component.exports